export const tr = {
    country: 'Ülke',
    disclaimer: 'Uyarı'
};
